import { Pipe, PipeTransform } from '@angular/core';
import { SharryVariant, SharryVariantDefinition } from 'src/types/graphql';
import { Variant } from 'utils/variant';
import { removeArrayDuplicates } from '../../utils/helpers';

@Pipe({
  name: 'variantDate',
  standalone: true,
})
export class VariantDatePipe implements PipeTransform {
  transform(value: Partial<SharryVariant>[]): Date {
    return (
      removeArrayDuplicates(
        (value || [])
          .filter(v => !!v && !v.default)
          .map(v => v?.definitions)
          .flat(),
      ) as SharryVariantDefinition[]
    ).find(v => v?.definitionType === Variant.DateTime)?.beginsAt;
  }
}
